import { PagedResponse } from '@elotech/components';
import { AxiosPromise } from 'axios';
import { FastField, Field, FieldProps } from 'formik';

import { AtribuicaoSearch, AtribuicaoSearchProps } from './AtribuicaoSearch';

type FormikResponsavelSearchProps<T> = Partial<AtribuicaoSearchProps<T>> & {
  fast?: boolean;
  name: string;
  getOptionLabel: (option: T) => string;
  onSearch: (search: string) => AxiosPromise<PagedResponse<T>>;
};

const FormikAtribuicaoSearch = <T,>({
  name,
  fast = true,
  onSelect,
  getOptionLabel,
  ...props
}: FormikResponsavelSearchProps<T>) => {
  const FormikField = fast ? FastField : Field;

  return (
    <FormikField
      name={name}
      render={({ field: { onChange, ...fieldProps }, form }: FieldProps) => {
        return (
          <AtribuicaoSearch<T>
            {...props}
            {...fieldProps}
            getOptionLabel={getOptionLabel}
            onSelect={(name, value) => {
              if (onSelect) {
                onSelect(name, value);
              } else {
                form.setFieldValue(name, value);
                form.setFieldTouched(name, true);
              }
            }}
            error={form.errors[name]}
          />
        );
      }}
    />
  );
};

export { FormikAtribuicaoSearch };
